import MainApp from "./pages";
import { useUserInfo } from "./context/user";
import Authentication from "./pages/authentication";
import Integration from "./integration";
import AppIntegration from "./appIntegration";
import SSOIframe from "./pages/SSOIframe";
import GDriveChatUI from "./pages/GDriveChatUI";
import FreeTrail from "./pages/FreeTrail";
import SetPassword from "./pages/SetPassword";
import Onboarding from "./pages/Onboarding/Onboarding";
import IntegrationApp from "./pages/IntegrationApp";
import SignInPage from "./pages/authentication/sign-in";
import Signup from "./pages/authentication/sign-up";
import VerifyEmail from "./pages/authentication/VerifyEmail";
import AccountSetup from "./pages/authentication/account-setup";
import { useUsersContext } from "./context/usersContext";
import AddPayment from "./pages/authentication/add-payment";
import { useCallback } from "react";

const useRoutes = () => {
  const [user, , , , userActiveLocation, , , , , , , , , , , , , , , , path] = useUserInfo();
  const { products } = useUsersContext();
  const activePlan = products.filter((item) => item.activePlan)
  const isAuthenticated = Object.keys(user || {})?.length > 0
  const isActiveLocation = userActiveLocation && Object.keys(userActiveLocation).length > 0
  const isOnboardingCompleted =
    Boolean(
      userActiveLocation?.onboarding &&
      Object.keys(userActiveLocation.onboarding).length > 0
    );

  const redirectRoute = useCallback(() => {
    if (!isAuthenticated)
      return '/auth/sign-in';

    if (isAuthenticated && !user?.verified)
      return path.includes('token') && path.includes('verify-email') ? path : '/auth/verify-email'

    if (
      isAuthenticated &&
      user?.verified &&
      (!isActiveLocation ||
        (!userActiveLocation?.business_name || !userActiveLocation?.team_size))
    )
      return '/auth/account-setup';

    if (
      isAuthenticated &&
      user?.verified &&
      isActiveLocation &&
      (userActiveLocation?.business_name || userActiveLocation?.team_size) &&
      !isOnboardingCompleted &&
      !path.includes('account-setup')
    )
      return '/onboarding';

    if (
      isAuthenticated &&
      user?.verified &&
      isActiveLocation &&
      isOnboardingCompleted &&
      (
        !userActiveLocation?.subscription_id &&
        userActiveLocation?.type !== 'free' &&
        !activePlan?.is_saas_free
      )
    )
      return '/auth/add-payment';

    if (
      isAuthenticated &&
      user?.verified &&
      isActiveLocation &&
      isOnboardingCompleted &&
      (
        userActiveLocation?.subscription_id ||
        userActiveLocation?.type === 'free' ||
        activePlan?.is_saas_free
      ) &&
      (user?.user_type === 'chat' || user?.user_type === undefined)
    )
      return path?.includes('app') ? path : '/app/chat';

    return '/integration-app';
  }, [isAuthenticated, user, userActiveLocation, isActiveLocation, activePlan]);


  return [
    {
      type: "collapse",
      key: "not_found",
      route: "/404",
      component: <></>,
    },
    {
      route: "/app/iframe",
      component: <SSOIframe />,
    },
    {
      type: "collapse",
      key: "integration",
      route: "/integrations/*",
      component: <Integration />,
    },
    {
      type: "collapse",
      key: "sign-up",
      route: "/auth/sign-up",
      component: <Signup />,
      guard: {
        valid:
          !isAuthenticated && !window.location.hostname.includes('midahub'),
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "sign-in",
      route: "/auth/sign-in",
      component: <SignInPage />,
      guard: {
        valid:
          !isAuthenticated,
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "verify-email",
      route: "/auth/verify-email",
      component: <VerifyEmail />,
      guard: {
        valid:
          (!isAuthenticated || !user?.verified) || path.includes('token'),
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "account-setup",
      route: "/auth/account-setup",
      component: <AccountSetup />,
      guard: {
        valid:
          isAuthenticated && user?.verified && !isOnboardingCompleted,
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "onboarding",
      route: "/onboarding",
      component: <Onboarding />,
      guard: {
        valid:
          isAuthenticated && user?.verified && isActiveLocation && !isOnboardingCompleted,
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "add-payment",
      route: "/auth/add-payment",
      component: <AddPayment />,
      guard: {
        valid:
          isAuthenticated && user?.verified && (!activePlan?.is_saas_free || !userActiveLocation.subscription_id || userActiveLocation.type !== 'free'),
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "authentication",
      route: "/:encrypted/auth/*",
      component: <Authentication />,
      guard: {
        valid:
          !isAuthenticated,
        redirect: redirectRoute(),
      },
    },
    {
      type: "collapse",
      key: "home",
      route: "/app/*",
      component: <MainApp />,
      guard: {
        valid: isAuthenticated && (user?.user_type === 'chat' || user.user_type === undefined) && isActiveLocation,
        redirect: `/auth/sign-in`,
      },
    },
    {
      type: "collapse",
      key: "home",
      route: "/:encrypted/app/*",
      component: <MainApp />,
      guard: {
        valid: isAuthenticated && isActiveLocation && (user?.user_type === 'chat' || user.user_type === undefined),
        redirect: `/auth/sign-in`,
      },
    },
    {
      type: "collapse",
      key: "gdrive_chatui",
      route: "/gdrive",
      component: <GDriveChatUI />,
    },
    {
      type: "collapse",
      key: "free_trail",
      route: "/free-trial",
      component: <GDriveChatUI />,
    },
    {
      type: "collapse",
      key: "freetrial",
      route: "/auth/free-trial",
      component: <FreeTrail />,
    },
    {
      type: "collapse",
      key: "freetrial",
      route: "/auth/reset-password",
      component: <SetPassword />,
    },
    {
      type: "collapse",
      key: "integration",
      route: "/app-integrations/*",
      component: <AppIntegration />,
    },
    {
      type: "collapse",
      key: "integration-app",
      route: "/integration-app/*",
      component: <IntegrationApp />,
    },
  ];
};

export default useRoutes;
